import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../../slice';
import {
  selectNotSelectedMappedFields,
  selectOnlySelectedMappedFieldsFilteredByCulture,
  selectVisibleRoutesBySelectedTaskFieldSeasonId,
} from '../../../slice/selectors';
import { IMappedField, MapModeEnum } from '../../../slice/types';
import DisabledField from '../../fields/DisabledField/DisabledField';
import { Field } from '../../fields/Field/Field';

const TaskFields = () => {
  const selectedFields = useSelector(
    selectOnlySelectedMappedFieldsFilteredByCulture,
  );
  const notSelectedFields = useSelector(selectNotSelectedMappedFields);
  const selectedFieldSeasonId = useSelector(
    selectVisibleRoutesBySelectedTaskFieldSeasonId,
  );

  const dispatch = useDispatch();

  const { actions: mapActions } = useMapSlice();

  useEffect(() => {
    if (selectedFields.length) {
      dispatch(mapActions.fitAllPolygonsOnMap());
    }
  }, [dispatch, mapActions, selectedFields.length]);

  const onFieldClick = (field: IMappedField) => {
    dispatch(mapActions.zoomOnPolygon(field.fieldParameters.fieldId));
    dispatch(
      mapActions.setVisibleRoutesBySelectedTaskFieldSeasonId(
        selectedFieldSeasonId === field.fieldParameters.fieldId
          ? null
          : field.fieldParameters.fieldId,
      ),
    );
  };

  return (
    <>
      {selectedFields.map(mappedField => (
        <Field
          mode={MapModeEnum.taskFields}
          eventHandlers={{
            click() {
              onFieldClick(mappedField);
            },
          }}
          mappedField={mappedField}
          key={mappedField.id}
          isSelected={false}
        />
      ))}
      {notSelectedFields.map(mappedField => (
        <DisabledField mappedField={mappedField} key={mappedField.id} />
      ))}
    </>
  );
};

export default TaskFields;
